<template>
  <div class="solicitacoes-tab-container">
    <box v-if="requests.length > 0" :title="t('Solicitações do Cliente')">
      <SOOrderItemRequestsVerifier
        :requests="requests"
        @request-verified="handleRequestVerified"
      />
    </box>
    <div v-else class="no-requests">
      {{ t('Nenhuma solicitação encontrada') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../../eventBus';
import { useSOOrderItemRequests } from '../../../composables/useSOOrderItemRequests';

const { t } = useI18n();

const props = defineProps<{
  itemId: number;
}>();

const { fetchByOrderItem } = useSOOrderItemRequests();
const requests = ref<unknown[]>([]);

async function loadData() {
  try {
    const result = await fetchByOrderItem(props.itemId);
    requests.value = result || [];
  } catch (err) {
    // Error handled by composable
  }
}

function handleRequestVerified() {
  eventBus.emit('so-order-item.updated', { itemId: props.itemId });
}

defineExpose({ loadData });
</script>

<style scoped>
.solicitacoes-tab-container {
  display: flex;
  flex-direction: column;
}

.no-requests {
  font-size: 0.875rem;
  color: var(--p-text-muted-color);
  padding: 0.5rem 0;
}
</style>
